<template>
  <div>
    <Search></Search>
    <div class="shop-item-path">
      <div class="shop-nav-container">
        <Breadcrumb>
          <BreadcrumbItem to="/">首页</BreadcrumbItem>
        </Breadcrumb>
      </div>
    </div>
    <!-- 商品信息展示 -->
    <GroupGoods :info="info"></GroupGoods>
    <!-- 商品详细展示 -->
    <ShowGoodsDetail :info="info"></ShowGoodsDetail>
  </div>
</template>

<script>
import Search from "@/components/pc/Search";
import GroupGoods from "@/components/pc/activities/GroupGoods";
import ShowGoodsDetail from "@/components/pc/goodsDetail/ShowGoodsDetail";
import { getCombinationDetail } from "@api/activity";
export default {
  name: "GroupDetail",
  created() {
    this.getProductInfo();
  },
  data() {
    return {
      info: {}
    };
  },

  methods: {
    getProductInfo() {
      const index = this.$route.params.id;
      getCombinationDetail(index).then(res => {
        this.info = res.data;
      });
    }
  },
  components: {
    Search,
    GroupGoods,
    ShowGoodsDetail
  }
};
</script>

<style scoped>
.shop-item-path {
  height: 38px;
  background-color: rgb(236, 235, 235);
  line-height: 38px;
  color: #2c2c2c;
}
.shop-nav-container {
  margin: 0px auto;
  width: 80%;
}
</style>
